import $http from '@/resource';
import utils from '@/utils';
import {Message, Notice} from 'view-design';

const $api = {};


/**
 * 获取用户基本信息
 *
 * @param {Object} data 含有uid
 *
 * @returns {Promise<any>}
 */
$api.userinfo = function(uid) {
	const url = `userinfo/${uid}`;
	const promise = new Promise(function(resolve){
		$http.get(url).then(function (response) {
		  	if (response.code == 200) {
		  	  	resolve(response.data);
		  	}else{
		  		utils.notice(response.msg, 'error');
		  	}
		});
	});
  	return promise;
}

/**
 * 解绑微信
 * 
 * @param {Object} data 含有手机号，短信验证码
 *
 * @returns {Promise<any>}
 */
$api.wechatBinding = data => {
	const url = 'wechat-unbind';
	const promise = new Promise(function(resolve){
		$http.put(url, data).then(function (response) {
		  	if (response.code == 200) {
		  		utils.notice(response.msg, 'success');
		  		resolve();
		  	}else{
		  		utils.notice(response.msg, 'error');
		  	}
		});
	});
  	return promise;
}

/**
 * 单位管理员
 *
 * @returns {Promise<any>}
 */
$api.companyAdministrators = () => {
	const url = 'company-administrators';
	const promise = new Promise(function(resolve){
		$http.get(url).then(function (response) {
		  	if (response.code == 200) {
		  		resolve(response.data);
		  	}else{
		  		utils.notice(response.msg, 'error');
		  	}
		});
	});
  	return promise;
}

/**
 * 更新用户信息
 * 
 * @param {Object} data 用户基本信息数据
 * @param {int} uid 当前用户uid
 *
 * @returns {Promise<any>}
 */
$api.updateUserinfo = (data, uid) => {
	const url = `userinfo/${uid}`;
	const promise = new Promise(function(resolve, reject){
		$http.put(url, data).then(function (response) {
		  	if (response.code == 200) {
		  		resolve(response);
		  	}else{
		  		utils.notice(response.msg, 'error');
		  		reject();
		  	}
		});
	});
  	return promise;
}


export default $api; 


// WEBPACK FOOTER //
// ./src/service/usercenter/info.js